import api from './api';

export interface User {
  id: number;
  cpf?: string;
  email: string;
  name: string;
  role: string;
  cnpj?: string;
  created_at: string;
  updated_at: string;
}

export interface CreateClinicRequest {
  cnpj: string;
  email: string;
  name: string;
}

export interface CreateClinicResponse {
  user: User;
  password: string;
}

export interface CreateAdminRequest {
  email: string;
  name: string;
  password: string;
}

export interface CreateAdminResponse {
  user: User;
}

export interface UsersListResponse {
  users: User[];
}

export const adminService = {
  async listUsers(): Promise<UsersListResponse> {
    const response = await api.get('/admin/users');
    return response.data;
  },

  async createClinic(data: CreateClinicRequest): Promise<CreateClinicResponse> {
    const response = await api.post('/admin/clinics', data);
    return response.data;
  },

  async createAdmin(data: CreateAdminRequest): Promise<CreateAdminResponse> {
    const response = await api.post('/admin/admins', data);
    return response.data;
  },

  async deleteUser(userId: number): Promise<void> {
    await api.delete(`/admin/users/${userId}`);
  },
};
